/**
 * Stage B/F.1 — is this ticket on the backlog ("Parking Lot") board?
 *
 * A SCHEDULING question, not a location one. Before B/F.1 "move to parking
 * lot" also rewrote the vehicle's location, so `parking_lot` alone answered
 * both. Now a backlog action leaves a car that is physically in a bay exactly
 * where it is (scheduling is not vehicle movement) and only takes the work off
 * the active schedule: no technician, with the backlog reason recorded. Such a
 * ticket must still be listed with the backlog, or it would vanish from the
 * board.
 */
export interface BacklogCandidate {
  parking_lot?: boolean | null;
  assigned_tech_id?: string | null;
  parking_lot_reason?: string | null;
}

export function isOnBacklogBoard(t: BacklogCandidate): boolean {
  if (t.parking_lot === true) return true;
  return t.assigned_tech_id == null && !!t.parking_lot_reason;
}
